/** @jsx jsx */
import { cssMap, jsx } from '@atlaskit/css';

import { SpotlightCard } from '@atlaskit/onboarding';
import { layers } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../../../../../../common/messages.tsx';
import type { SpotlightContainerProps } from './types.tsx';

export const SpotlightContainer = ({ children }: SpotlightContainerProps) => {
	const { formatMessage } = useIntl();

	/**
	 * Atlaskit Popup was not used due to technical limitations of the component in this particular use case.
	 * onClose is triggered when the popup is controlled by focussing, which causes the popup to immediately close.
	 */

	return (
		<div
			css={styles.spotlightContainerWrapper}
			data-testid="issue-create.ui.modal.modal-wrapper.minimizable-modal-modal.header.spotlight-container.wrapper"
		>
			{children}
			<div css={styles.spotlightPopoverWrapper}>
				<SpotlightCard width={275}>
					{formatMessage(
						expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? messages.resizeSpotlightMessageIssueTermRefresh
							: messages.resizeSpotlightMessage,
					)}
				</SpotlightCard>
			</div>
		</div>
	);
};

const styles = cssMap({
	spotlightPopoverWrapper: {
		position: 'absolute',
		marginTop: token('space.075'),
		right: token('space.negative.025'), // Size of the border of the SpotlightPulse
		zIndex: layers.spotlight(),
	},
	spotlightContainerWrapper: {
		position: 'relative',
	},
});
